module.exports = __webpack_public_path__ + "static/img/iconhomeactive.45815ecd.svg";